const { INCLUDED_SC_NAVIGATION_TILES_TEST } = require('./constants');

const shoudlShowTileCaoursel = ({ isTouch, subCatFiltersCarousel, subCategoryId, inNavigationTilesSCTest }) =>
    !isTouch &&
    (prevTestSubCategory(subCatFiltersCarousel, subCategoryId) ||
    newTestSubCategoryAndInTest(subCatFiltersCarousel, subCategoryId, inNavigationTilesSCTest));

const prevTestSubCategory = (subCatFiltersCarousel, subCategoryId) =>
    subCatFiltersCarousel && !INCLUDED_SC_NAVIGATION_TILES_TEST.includes(subCategoryId);

const newTestSubCategoryAndInTest = (subCatFiltersCarousel, subCategoryId, inNavigationTilesSCTest) =>
    subCatFiltersCarousel && INCLUDED_SC_NAVIGATION_TILES_TEST.includes(subCategoryId) && inNavigationTilesSCTest;

module.exports = {
    shoudlShowTileCaoursel
};
